import React, { useState } from 'react';

import { IAssigneeOptionsList, useAssigneeOptionsList } from 'hooks/useAssigneeOptionsList';

import { AssigneeAvatar } from 'components/common/AssigneeAvatar/AssigneeAvatar';
import { AssigneeList } from 'components/common/AssigneeAvatarWithSelection/AssigneeList';

import { IAssignee } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

import classes from './AssigneeAvatarWithSelection.module.scss';

interface IAssigneeAvatarWithSelection {
    assignee: IAssignee | null;
    handleSelection: (value: string) => void;
    isDisabled?: boolean;
    classname?: string;
}

export const AssigneeAvatarWithSelection = ({
    assignee,
    handleSelection,
    isDisabled = false,
    classname = '',
}: IAssigneeAvatarWithSelection) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [menuOpen, setMenuOpen] = useState<boolean>(false);

    const { options: assigneeOptionsList } = useAssigneeOptionsList();

    const handleMenuOpen = (event) => {
        event.stopPropagation();
        event.preventDefault();
        if (isDisabled) return; // We don't want to perform any action is the component is disabled
        setAnchorEl(event.currentTarget);
        setMenuOpen(!menuOpen);
    };

    const handleAssigneeSelection = (e: React.MouseEvent, value: IAssigneeOptionsList) => {
        e.stopPropagation();
        handleSelection(value.value || 'Unassigned');
    };

    return (
        <>
            <div
                data-testid={'assignee-avatar'}
                className={`${classes.assigneeAvatarWithSelectionContainer} ${isDisabled ? classes.disabled : ''}`}
                onClick={handleMenuOpen}
            >
                {assignee && <AssigneeAvatar assignee={assignee} classname={classname} />}
            </div>
            <AssigneeList
                anchorEl={anchorEl}
                setAnchorEl={setAnchorEl}
                setMenuOpen={setMenuOpen}
                menuOpen={menuOpen}
                assigneeOptionsWithDefault={assigneeOptionsList}
                handleAssigneeSelection={handleAssigneeSelection}
                assigneeValue={assignee}
            />
        </>
    );
};
